export function preventMinusCharacter(event) {
    if (!event) return
    if (event.key === "-" || event.key === "e") {
        event.preventDefault()
    }
    return event
}

export function limitDecimalPlaces(value: string, decimalPlaces: number | undefined): string {
    if (!value) return value
    if (decimalPlaces === undefined) return value
    const dotIndex = value.indexOf(".")
    if (dotIndex === -1) return value
    const integerPart = value.slice(0, dotIndex)
    if (decimalPlaces <= 0) return integerPart
    const fractionalPart = value.slice(dotIndex + 1).replace(/\D/g, "")
    return `${integerPart}.${fractionalPart.slice(0, decimalPlaces)}`
}
